import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { ValidationResultType } from "src/app/enum";

@Component({
  selector: "section-expanding",
  templateUrl: "./section-expanding.component.html",
  styleUrls: ['./section-expanding.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SectionExpandingComponent {


  @Output() public onExpandedChange = new EventEmitter();

  @Input() public expanded = true;
  @Input() public hideWhenExpanded = false;
  @Input() public headerFullWidth = false;
  @Input() public validationResultType: ValidationResultType = ValidationResultType.None;
  @Input() public speed = 250;

  public toggleExpand() {
    this.expanded = !this.expanded;
    this.onExpandedChange.emit(this.expanded);
  }

}
